import { createInteractiveColorVars } from '../../helpers/createInteractiveColorVars/index.js';

const PositiveColors = createInteractiveColorVars('positive');
const PositiveColorsLightValues = Object.freeze({
    base: {
        default: '#ffffff',
        action: '#B4B4B4',
        active: '#ffffff',
        activeAction: '#B4B4B4',
    },
    text: {
        default: '#000000',
        action: '#000000',
        active: '#000000',
        activeAction: '#000000',
    },
});
const PositiveColorsDarkValues = Object.freeze({
    base: {
        default: '#000000',
        action: '#787878',
        active: '#000000',
        activeAction: '#787878',
    },
    text: {
        default: '#ffffff',
        action: '#ffffff',
        active: '#ffffff',
        activeAction: '#ffffff',
    },
});

export { PositiveColors, PositiveColorsDarkValues, PositiveColorsLightValues };
